import DOMElementMultiSetClassManager from './classes/DOMElementMultiSetClassManager';

const bodyClassManager = new DOMElementMultiSetClassManager(
    'body',
    window.document,
);

export default bodyClassManager;
